import { types as t, Instance } from 'mobx-state-tree';
import { ModelV2 } from '~/mst/models/abstract/model';
import Syncable from '~/mst/models/abstract/syncable';
import Fetchable from '~/mst/models/abstract/fetchable';
import MaybeString from '~/mst/models/abstract/maybe_string';
import CreatedAtModel from '~/mst/models/abstract/created_at';
import ConfigurationModel from './configuration';
import ReportAssetsCollectionModel from './assets';
import { ReportRunTypes } from './types';

const ReportModel = t.compose(
  t.model({
    name: t.maybeNull(t.string),
    description: t.maybeNull(MaybeString),
    organization_id: t.maybeNull(t.string),
    user_id: t.maybeNull(t.string),
    next_email_sent_at: t.maybeNull(t.string),
    subscribers: t.maybeNull(t.array(t.string)),
    run_type: t.optional(t.enumeration('RunType', Object.values(ReportRunTypes)), ReportRunTypes.once),
    configuration: t.maybeNull(ConfigurationModel),
    assets: t.maybeNull(ReportAssetsCollectionModel),
    job_statuses: t.frozen()
  }),
  ModelV2,
  Syncable,
  Fetchable({ cache: true }),
  CreatedAtModel
);

export interface IReportModel extends Instance<typeof ReportModel> {}

export default ReportModel;
